import { render } from "./t-confirm.vue?vue&type=template&id=24e3c27c&scoped=true"
import script from "./t-confirm.vue?vue&type=script&lang=js"
export * from "./t-confirm.vue?vue&type=script&lang=js"

import "./t-confirm.vue?vue&type=style&index=0&id=24e3c27c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e3c27c"]])

export default __exports__